import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-1 fw-b" }

import { computed as _computed } from 'vue';

import { IonCol, IonRow, } from "@ionic/vue";
import { useForm } from "vee-validate";

import TextareaSimple from "@/components/input/TextareaSimple.vue";
import InputFile from "@/components/input/InputFile.vue";
import InputSimple from "@/components/input/InputSimple.vue";

import { FeedbackTicketTemplate } from "@/types/request";

import { ISSUE_TYPE } from "@/types/enum/general"
import { FeedbackBugProps } from "@/types/props";
import { FeedbackBugEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackBug',
  props: {
    modelValue: {},
    files: {},
    show: { type: Boolean }
  },
  emits: ["update:modelValue", "file"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
const props = __props
const emit = __emit

const descriptionTemplate = _computed<FeedbackTicketTemplate>({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value)
    }
})

const { meta, resetForm, validate } = useForm({
    validationSchema: {
        issue: 'required',
        expectation: 'required',
        place: 'required',
        steps: 'required'
    }
})

__expose({
    meta,
    resetForm,
    validate
})

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.${_unref(ISSUE_TYPE).BUG}.issue`)) + "* ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createVNode(InputSimple, {
                  modelValue: descriptionTemplate.value.issue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((descriptionTemplate.value.issue) = $event)),
                  "validate-option": { name: 'issue', label: _ctx.$t('label.issue') },
                  "input-class": "grey4-grey4-background"
                }, null, 8, ["modelValue", "validate-option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.${_unref(ISSUE_TYPE).BUG}.place`)) + "* ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createVNode(TextareaSimple, {
                  modelValue: descriptionTemplate.value.place,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((descriptionTemplate.value.place) = $event)),
                  "validate-option": { name: 'place', label: _ctx.$t('label.place') },
                  "textarea-class": "grey4-grey4-background"
                }, null, 8, ["modelValue", "validate-option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.${_unref(ISSUE_TYPE).BUG}.expectation`)) + "* ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createVNode(TextareaSimple, {
                  modelValue: descriptionTemplate.value.expectation,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((descriptionTemplate.value.expectation) = $event)),
                  "validate-option": { name: 'expectation', label: _ctx.$t('label.expectation') },
                  "textarea-class": "grey4-grey4-background"
                }, null, 8, ["modelValue", "validate-option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.${_unref(ISSUE_TYPE).BUG}.steps`)) + "* ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createVNode(TextareaSimple, {
                  modelValue: descriptionTemplate.value.steps,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((descriptionTemplate.value.steps) = $event)),
                  "validate-option": { name: 'steps', label: _ctx.$t('label.steps') },
                  "textarea-class": "grey4-grey4-background"
                }, null, 8, ["modelValue", "validate-option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (__props.files.length > 0)
          ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('label.files')) + ": ", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.files, (file, counter) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: counter,
                        class: "mb-1"
                      }, _toDisplayString(file.name), 1))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "auto",
              class: "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('label.uploadImage')) + ": ", 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createVNode(InputFile, {
                  multiple: "",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (emit('file', $event)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.upload')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})